module.exports = __webpack_public_path__ + "static/img/shadowPlay_wx.c67158d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/shadowPlay_wx.png
// module id = MV/U
// module chunks = 26